import React from 'react';
import {ProvenExpertStar} from '../dato/block/provenExpert/ProvenExpertStar';
import {getDecimalPart, getWholePart} from '../../utils/numberUtils';
import ProvenExpertRatingData from '../../../static/json/ProvenExpertRating.json';

export const ProvenExpertStarRating = ({height, width, color, stopColor = 'transparent'}: Omit<ProvenExpertStar, 'fill'>) => {
  const filledStars = getWholePart(ProvenExpertRatingData.ratingValue),
    partiallyFilledStar = getDecimalPart(ProvenExpertRatingData.ratingValue);

  return (
    <div className='sm:flex sm:flex-row sm:justify-start sm:items-center'>
      <div className='flex flex-row justify-center items-center sm:justify-start'>
        {Array.from({length: filledStars}, (_, index) => (
          <ProvenExpertStar height={height} width={width} color={color} key={`proven-expert-star-${index}`} fill={1} />
        ))}
        <ProvenExpertStar stopColor={stopColor} height={height} width={width} color={color} fill={partiallyFilledStar} />
      </div>
    </div>
  );
};
